module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Facilitator guide"},"fi":{"title":"Pelinjohtajan ohjeet"},"sv":{"title":"Instruktioner för spelledare"},"de":{"title":"Anweisungen für den Moderator"},"ko":{"title":"퍼실리테이터 가이드"}}')
  delete Component.options._Ctor
}
